window.addEventListener('DOMContentLoaded', renderAllCarousels);

function renderAllCarousels() {
  const glideElements = document.querySelectorAll('.glide');
  glideElements.forEach(initializeGlide);
}

function initializeGlide(element) {
  import(/* webpackChunkName: "cobp-glide" */ './cobp-glide').then(
    ({ Glide }) => {
      console.log(element.dataset);
      const { type, autoplay, perview, gap, bound } = element.dataset;

      new Glide('.glide', {
        perView: perview,
        autoplay: autoplay === 'false' ? false : autoplay,
        type,
        gap,
        bound,
      }).mount();
    }
  );
}
